
import { BlogSection } from '@/types/blog';

export const selbstreflektion: BlogSection = {
  id: 'selbstreflektion',
  title: 'Selbstreflektion: Wo stehe ich?',
  content: `
<p class="mb-4">
  Diese Weisheit lädt uns nicht nur ein, andere zu beurteilen, sondern vor allem, uns selbst zu betrachten. In verschiedenen Lebensbereichen befinden wir uns in unterschiedlichen Kategorien:
</p>

<ul class="list-disc pl-6 space-y-2 mb-6">
  <li>In manchen Bereichen sind wir Anfänger, die noch nichts wissen – und das ist in Ordnung.</li>
  <li>In anderen erkennen wir unsere Wissenslücken und sind bereit zu lernen – der fruchtbarste Zustand.</li>
  <li>Manchmal ertappen wir uns dabei, dass wir über Dinge sprechen, von denen wir weniger verstehen als wir glauben.</li>
  <li>Gelegentlich haben wir Fähigkeiten und Einsichten, die wir vernachlässigen oder vergessen haben.</li>
  <li>Und in einigen wenigen Bereichen haben wir tiefes Wissen und die Weisheit, es angemessen einzusetzen.</li>
</ul>

<p class="mb-6">
  Im Bereich der Finanzen und des Finanzcoachings sehe ich besonders häufig Menschen, die sich in den ersten drei Kategorien bewegen:
</p>

<div class="bg-joerg-50 p-6 rounded-xl mb-6">
  <p class="mb-3">
    <span class="font-medium">Kategorie 1:</span> Menschen, die wissen, dass sie ihre Finanzen nicht verstehen und sich davor scheuen, sich damit auseinanderzusetzen.
  </p>
  <p class="mb-3">
    <span class="font-medium">Kategorie 2:</span> Menschen, die erkannt haben, dass sie handeln müssen und aktiv nach Wegen suchen, ihr Finanzwissen zu verbessern – sie sind ideal für Coaching.
  </p>
  <p>
    <span class="font-medium">Kategorie 3:</span> Menschen, die nach dem Lesen einiger Artikel oder Bücher glauben, alle Antworten zu haben, und möglicherweise riskante Entscheidungen treffen.
  </p>
</div>

<p class="text-lg font-medium mb-4">Drei Fragen zur Selbstreflektion:</p>

<ol class="list-decimal pl-6 space-y-3 mb-6">
  <li>In welchen Bereichen meines Lebens befinde ich mich in welcher Kategorie?</li>
  <li>Wer sind meine Lehrer und Vorbilder, und in welche Kategorie fallen sie?</li>
  <li>Wie kann ich mich bewusst in die Position des "Wissens, dass ich nicht weiß" begeben, um zu lernen und zu wachsen?</li>
</ol>

<div class="bg-primary/5 p-6 rounded-xl border border-primary/20 my-8">
  <p class="text-center text-lg italic">
    "Der erste Schritt zur Weisheit ist das Eingeständnis der eigenen Unwissenheit."
  </p>
</div>
  `,
};
